import {
  ExaminerTrainingStatus,
  ReportCertificationType,
  ReportMonitoringType,
  TrainingCategory,
  TrainingType,
} from 'api';

export const enumToOptions = <T>(
  enumObj: T,
  getName?: (value: T[keyof T]) => string
): Array<{ value: T[keyof T]; text: string }> =>
  Object.entries(enumObj as object)
    .filter(([key]) => isNaN(Number(key)))
    .map(([text, value]) => ({
      value: value,
      text: getName ? getName(value) : text,
    }));

export const trainingCategoryOptions = enumToOptions(TrainingCategory);
export const trainingTypeOptions = enumToOptions(TrainingType);
export const trainingStatusOptions = enumToOptions(ExaminerTrainingStatus);

export const ReportMonitoringTypeNames: Record<ReportMonitoringType, string> = {
  [ReportMonitoringType.Speaking]: 'Speaking',
  [ReportMonitoringType.Writing]: 'Writing',
  [ReportMonitoringType.LifeSkillsA1]: 'Life Skills A1',
  [ReportMonitoringType.LifeSkillsA2]: 'Life Skills A2',
  [ReportMonitoringType.LifeSkillsB1]: 'Life Skills B1',
  [ReportMonitoringType.Odp]: 'ODP',
};
export const reportMonitoringTypeOptions = enumToOptions(
  ReportMonitoringType,
  (value) => ReportMonitoringTypeNames[value]
);

export const ReportCertificationTypeNames: Record<ReportCertificationType, string> = {
  [ReportCertificationType.Speaking]: 'Speaking',
  [ReportCertificationType.Writing]: 'Writing',
  [ReportCertificationType.LifeSkillsA1]: 'Life Skills A1',
  [ReportCertificationType.LifeSkillsA2]: 'Life Skills A2',
  [ReportCertificationType.LifeSkillsB1]: 'Life Skills B1',
};
export const reportCertificationTypeOptions = enumToOptions(
  ReportCertificationType,
  (value) => ReportCertificationTypeNames[value]
);
